<template>
    <div class="order">
        <!-- 商品信息 -->
        <div class="sale-box">
            <div class="flex sale__item">
                <div class="img-box">
                    <img :src="product.cover_img" alt="">
                    <div class="tips">
                        <span class="fs_22 c_ff" v-if="product.type==1">实物</span>
                        <span class="fs_22 c_ff" v-else>虚拟</span>
                    </div>
                </div>
                <div class="flex__null__around sale__item__right">
                    <span class="fs_26 c_1a lh_36 ellipsis_two">{{product.name}}</span>
                    <span class="fs_26 c_80">x{{orders.number}}</span>
                    <div class="mt_10 lh_40">
                        <span class="fs_30 c_main" v-if="product.integral">{{product.integral}}<span class="fs_24">积分</span></span>
                        <span class="fs_24 c_main" v-if="product.integral&&product.money!='0.00'">+</span>
                        <span class="fs_28 c_main" v-if="product.money!='0.00'">{{product.money}}<span class="fs_24">元</span></span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="product.type==1">
            <!-- 到货方式 -->
            <div class="modular-box" @click="picker_show=true">
                <div class="flex__between__center modular__item bb_1">
                    <span class="fs_28 c_1a">到货方式</span>
                    <div class="lh_40">
                        <span class="fs_28 c_4d">{{product.deliver_type[transport_index].name}}</span>
                        <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
                    </div>
                </div>
            </div>
            <!-- 邮寄地址 -->
            <div v-if="orders.deliver_type_id==1">
                <div class="flex__between__center header nihao" v-link="'/Address/Index'">
                    <div class="flex__column" v-if="orders.linkman">
                        <span class="fs_34 c_1a lh_50">{{orders.linkman}}&emsp;{{orders.mobile_phone}}</span>
                        <span class="fs_28 c_80 lh_40">{{orders.province}}{{orders.city}}{{orders.area}}{{orders.address}}</span>
                    </div>
                    <span v-else class="fs_28 c_ 80 lh_40">请选择地址</span>
                    <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
                </div>
            </div>
            <!-- 自提地址 -->
            <div class="flex__between__center header" v-else @click="ensure_modal=true">
                <span class="fs_28 c_1a">自提地址</span>
                <div class="lh_40">
                    <span class="fs_28 c_4d">{{store[store_index].name}}</span>
                    <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
                </div>
            </div>
        </div>
        <!-- 附带信息 -->
        <div class="modular-box">
            <div class="flex__between__center modular__item" v-if="my_integral">
                <div>
                    <span class="fs_28 c_1a">需支付积分</span>
                    <span class="fs_26 c_98">(剩余积分{{my_integral}})</span>
                </div>
                <span class="fs_28 c_main">{{pay_integral}}</span>
            </div>
            <div class="flex__between__center modular__item" v-if="pay_money">
                <span class="fs_28 c_1a">需支付金额</span>
                <span class="fs_28 c_main">¥{{pay_money}}</span>
            </div>
            <div class="flex__between__center modular__item">
                <span class="fs_28 c_1a">备注</span>
                <input type="text" v-model="orders.remark" class="fs_28 c_4d" placeholder="请输入备注"/>
            </div>
        </div>
        <!-- 底部操作栏 -->
        <div class="flex__between__center footer">
            <div>
                <span class="fs_28 c_4d">实付：</span>
                <span class="fs_40 c_main" v-if="pay_integral">{{pay_integral}}<span class="fs_26">积分</span></span>
                <span class="fs_26 c_main" v-if="pay_integral&&pay_money!='0.00'">+</span>
                <span class="fs_30 c_main" v-if="pay_money!='0.00'">{{pay_money}}<span class="fs_24">元</span></span>
            </div>
            <button class="cancel" @click="pay">确认兑换</button>
        </div>
        
        <!-- 到货方式 picker -->
        <div class="picker-box" v-show="picker_show">
            <div class="layer" @click="picker_show=false"></div>
            <van-picker 
            class="van-picker" 
            show-toolbar
            :columns="product.deliver_type" 
            value-key="name"
            @cancel="picker_show=false"
            @confirm="setTransportway" />
        </div>
        <!-- 上门自提modal -->
        <div v-show="ensure_modal" class="ensure-box">
            <div class="layer" @click="ensure_modal=false"></div>
            <div class="ensure">
                <div class="ensure__content">
                    <p class="flex__around fs_34 c_1a">自提地址</p>
                    <div class="flex__between__center ensure-item" v-for="(item,index) in store" :key="index" @click="store_index=index;orders.store_id=item.id">
                        <div class="flex__column">
                            <div>
                                <span class="fs_36 c_1a lh_50">{{item.name}}</span>
                                <span class="fs_24 c_main">&nbsp;距离我{{item.distance}}</span>
                            </div>
                            <span class="fs_28 c_66 lh_40 mt_10">{{item.address}}</span>
                        </div>
                        <div>
                            <span class="jcicon jcicon-dui fs_34 c_main" v-if="orders.store_id==item.id"></span>
                            <span class="jcicon jcicon-unselected fs_34 c_98" v-else></span>
                        </div>
                    </div>
                </div>
                <button class="close-btn" @click="ensure_modal=false">关闭</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "IntegralOrder",
    data(){
        return{
            address_id: '',
            pay_integral: 0, //支付积分
            pay_money: 0, //支付金额
            my_integral: 0, //剩余积分
            transport_index: 0, //到货方式
            store_index: 0, //自提地址
            store: [], //自提门店
            picker_show: false, //到货方式picker
            ensure_modal: false, //门店自提 modal
            product: {
                deliver_type: [{}]
            },
            orders:{
                user_id: localStorage.user_id, 
                source: 1, //来源（非必填,1-微信公众号 2-小程序 默认为小程序）
                product_id: '', //立即购买商品ID（当 settlement_type = 2 时 必填）
                linkman: '', //联系人（必填）
                mobile_phone: '', //联系电话（必填）
                province: '', //省（必填）
                city: '', //市（必填）
                area: '', //区（必填）
                address: '', //详细地址（必填）
                number: '', //立即购买商品数量（当 settlement_type = 2 时 必填）
                deliver_type_id: 1, //提货方式（非必填 当商品为实物时必填 1--邮寄 2--上门自提 ）
                store_id: '', //自提门店id
                remark: '', //备注（非必填）
            }
        }
    },
    methods:{
        // 付款
        pay(){
            if(this.product.type==1){
                if(!this.address_id&&this.orders.deliver_type_id==1){
                    this.$toast('请选择地址');
                    return;
                }
                if(!this.orders.store_id&&!this.orders.deliver_type_id==2){
                    this.$toast('请选择自提门店');
                    return;
                }
            }
            this.httpPost({
                url:'/Integral/submitOrder',
                params:this.orders
            }).then(res=>{
                if(res.code==1){
                    if(res.data.pay_parameters){
                        this.$wx.wxPay(res.data.pay_parameters).then(api_res => {
                            this.$router.push('/Integral/Record?index=2');
                        }).catch(api_res=>{
                            this.$router.push('/Integral/Record?index=1');
                        })
                    }
                }else{
                    this.$dialog.alert({
                        message: res.message
                    })
                }
            })
        },
        // 支付方式
        setTransportway(value,index){
            this.picker_show=false;
            this.transport_index=index;
            this.orders.deliver_type_id=this.product.deliver_type[index].id;
        },
        // 获取地址
        getAddress(id){
            this.axios.post('/wechat.php/Address/getAddressData', {
                user_id: localStorage.user_id,
                id: id
            }).then(
                res=>{
                    this.orders.province=res.data.data.province;
                    this.orders.city=res.data.data.city;
                    this.orders.area=res.data.data.area;
                    this.orders.address=res.data.data.address;
                    this.orders.linkman=res.data.data.linkman;
                    this.orders.mobile_phone=res.data.data.mobile_phone;
                    this.address_id=res.data.data.id;
                }
            )
        }
    },
    mounted(){
        this.orders.product_id=this.$route.query.product_id;
        this.orders.number=this.$route.query.number;
        this.axios.post('/wechat.php/Integral/getOrderReadyData', {
            user_id: localStorage.user_id,
            product_id: this.$route.query.product_id,
            number: this.$route.query.number,
            lng: this.$route.query.lng,
            lat: this.$route.query.lat,
        }).then(
            res=> {
                this.pay_integral=res.data.data.pay_integral;
                this.pay_money=res.data.data.pay_money;
                this.my_integral=res.data.data.my_integral;
                this.product=res.data.data.product;
                // 默认地址
                if(this.$store.state.address_id){
                    // 通过id获取地址
                    this.getAddress(this.$store.state.address_id);
                }else{
                    this.orders.province=res.data.data.default_address.province;
                    this.orders.city=res.data.data.default_address.city;
                    this.orders.area=res.data.data.default_address.area;
                    this.orders.address=res.data.data.default_address.address;
                    this.orders.linkman=res.data.data.default_address.linkman;
                    this.orders.mobile_phone=res.data.data.default_address.mobile_phone;
                    this.address_id=res.data.data.default_address.id;
                }
                this.store=res.data.data.store;
                this.orders.store_id=this.store[0].id;
            }) 
    },
    destroyed(){
        this.$store.commit('setAddressId','');
    }
}
</script>
<style scoped>
.header{
    padding: 30px;
    background: #fff;
}
.sale-box{
    padding: 0 30px 30px;
    background: #fff;
    overflow: hidden;
}
.sale__item{
    margin-top: 30px;
}
.sale__item:last-child{
    border: 0;
}
.img-box{
    position: relative;
    width: 180px;
    height: 180px;
    flex-shrink: 0;
}
.img-box .tips{
    position: absolute;
    width: 60px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: #F93A42;
}
.img-box img{
    position: absolute;
    width: 180px;
    height: 180px;
    border-radius: 10px;
}
.sale__item__right{
    /* width: 480px; */
    margin-left: 30px;
}
/* info */
.modular-box{
    padding: 0 30px;
    margin-top: 15px;
    background: #fff;
}
.modular__item{
    height: 100px;
    border-bottom: 2px solid #e6e6e6;
}
.modular__item:last-child{
    border: 0;
}
.modular__item input{
    width: 500px;
    text-align: right;
}
/* footer */
.footer{
    position: fixed;
    width: 100%;
    bottom: 0;
    padding-left: 30px;
    height: 98px;
    background: #fff;
}
.footer__left{
    padding: 0 30px;
}
.cancel{
    width: 250px;
    height: 98px;
    margin-left: 30px;
    background: #F93A42;
    color: #fff;
    font-size: 32px;
}
/* modal */
.picker-box{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    z-index: 1;
}
.van-picker{
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 2;
}
/* modal */
.layer{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 2;
}
.ensure{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 3;
    background: #fff;
}
.ensure__content{
    min-height: 700px;
    padding: 30px;
    overflow: auto;
}
.ensure-item{
    padding: 30px 0;
    border-top: 2px solid #e6e6e6;
}
.ensure-item:nth-child(2){
    border: 0;
}
.ensure-item img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
}
.ensure-item__right{
    height: 60px;
    margin-left: 20px;
}
.close-btn{
    width: 100%;
    height: 98px;
    background: #F93A42;
    color: #fff;
    font-size: 32px;
}
</style>





// WEBPACK FOOTER //
// src/pages/integral/Order.vue